import React from 'react'

const About = () => {
  return (
    <div className='pt-24'> About</div>
    
  )
}

export default About